export default __webpack_public_path__ + "static/media/ontology-search.5ba845e7.gif";